<template>
  <div class="container-material hold">
    <div class="top">
      <div class="tp">
        <div class="flt">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="14px" height="14px" viewBox="0 0 971.986 971.986" style="enable-background:new 0 0 971.986 971.986;" xml:space="preserve" class=""><g><g><path d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3   c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873   c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z" data-original="#000000" class="active-path" data-old_color="##4D4F5" fill="rgba(77, 79, 92, 0.5)"/></g></g> </svg>
          Filters
        </div>
        <div class="srch">
          <input type="search" placeholder="Search Classes" class="form-control" v-model="query">
        </div>
      </div>
      <div class="input-group input-daterange hide-on-small-only">
        <div class="col-sm-6">
          <datepicker v-model="from" placeholder="From" id="exampleInputEmail3" input-class="date-picker" :clear-button="true"></datepicker>
        </div>
        <div class="col-sm-6">
          <datepicker v-model="to" placeholder="To" id="exampleInputEmail4" input-class="date" :clear-button="true"></datepicker>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="tp">
        <p>Classes <span>{{ filtered.length }}</span></p>
        <div class="sasasa"></div>
      </div>
      <div class="table-responsive" v-if="doneLoading">
        <table class="table">
          <thead>
            <tr>
              <td>Client Name</td>
              <td>Client ID</td>
              <td>Status</td>
              <td>Client's Phone Number</td>
              <td>Action</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="c of filtered" :key="c.id">
              <td><router-link :to="{ name: 'tutor-class', params: { id: c.id }}">{{ c.client && c.client.name }}</router-link></td>
              <td>{{ c.client && c.client.id }}</td>
              <td class="status"><span :class="c.status ? c.status.name.toLowerCase() : 'default'"></span> {{ c.status && c.status.name }}</td>
              <td>{{ c.client && c.client.phone }}</td>
              <td>
                <b-dropdown variant="link" size="lg" no-caret id="dsdag">
                  <template slot="button-content">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 612 612" style="enable-background:new 0 0 612 612;" xml:space="preserve" class=""><g><g><g><circle cx="69.545" cy="306" r="69.545" data-original="#000000" class="active-path" data-old_color="#000000" fill="#3B86FF"/><circle cx="306" cy="306" r="69.545" data-original="#000000" class="active-path" data-old_color="#000000" fill="#3B86FF"/><circle cx="542.455" cy="306" r="69.545" data-original="#000000" class="active-path" data-old_color="#000000" fill="#3B86FF"/></g></g></g> </svg>
                  </template>
                  <b-dropdown-item href="#" @click.prevent="showModal(c.id)">Make Complaint</b-dropdown-item>
                  <b-dropdown-item href="#" @click.prevent="showCalendar(c.id)">Submit Lesson</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="row justify-content-center">
        <div class="col text-center">
          <broken-spinner color="#554971" :thickness="2" />
        </div>
      </div>
      <b-modal ref="myModalRef" hide-footer size="lg" centered class="mkmodal" title="Make Complaint">
        <div class="d-block text-center">
          <div class="form-group">
            <input type="text" placeholder="Summary" v-model="summary" class="form-control">
          </div>
          <div class="form-group">
            <select class="form-control" v-model="regarding">
              <option value="" selected disabled>Regarding</option>
              <option :value="category.id" v-for="category of categories" :key="category.id">{{ category.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <editor v-model="content" :config="editorConfig"></editor>
          </div>
          <button class="btn btn-success btn-lg submit-button" @click.prevent="submit" :disabled="submitting">Submit <i class="fa fa-spin fa-circle-o-notch" v-show="submitting"></i></button>
        </div>
      </b-modal>
      <!-- Submit ClassDates modal and form -->
      <b-modal ref="vcalendar" hide-footer :size="(modalIndex > 0) ? 'lg' : 'md'" centered class="mkmodal" :title="(modalIndex > 0) ? 'Learner\'s Performance Report' : 'Select your Lesson dates'">
        <div class="d-block text-center">
          <div v-if="modalIndex === 0">
            <v-date-picker mode="multiple" isInline v-model="selectedDates" :select-attribute="selectAttribute" :disabled-dates="disabledDates"></v-date-picker>
            <div class="labels">
              <p>
                <span style="background-color: #639440"></span>Uninvoiced Dates
              </p>
              <p>
                <span style="background-color: #d98c8c"></span> Invoiced Dates
              </p>
            </div>
          </div>
          <div v-else class="performance-report">
            <div class="form-group">
              <p class="title">Please list the specific topics you covered in your session</p>
              <div class="alert alert-success p-1">
                <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-1 font-italic">
                  <p class="sub-content">Remember !! Tutors that provide clean and good feedback about tutoring sessions have a better chance of getting more learner requests from us.</p>
                </blockquote>
              </div>
              <b-form-textarea rows="3" name="topics" type="text" placeholder="Topics you covered in your session" class="form-control" :class="{'is-invalid': errors.has('topics')}" v-validate="'required|min:10'" v-model="topics"></b-form-textarea><div class="invalid-feedback" v-show="errors.has('topics')">{{ errors.first('topics') }}</div>
            </div>

            <div class="form-group">
              <p class="title">What exact progress has the child made so far in the topics mentioned above?</p>
              <div class="alert alert-success p-1">
                <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-1 font-italic">
                  <p class="sub-content">e.g in mathematics, under algebra, he can now solve linear equations with only one variable, he can also solve inequalities with only one unknown. He can solve simultaneous equations that have 2 or 3 unknowns while in english, he can now differentiate between clauses and phrases and spell 5 letter words. In Chemistry understand gas theorems and can solve questions on Avogadro's law. Remember !! Tutors that provide clean and good feedback about tutoring sessions have a better chance of getting more learner requests from us.</p>
                </blockquote>
              </div>
              <b-form-textarea rows="3" name="progress" type="text" placeholder="Exact progress the child has made" id="titleish" class="form-control" :class="{'is-invalid': errors.has('progress')}" v-validate="'required|min:100'" v-model="progresss"></b-form-textarea><div class="invalid-feedback" v-show="errors.has('progress')">{{ errors.first('progress') }}</div>
            </div>

            <div class="form-group">
              <p class="title">Score your student's knowledge on the subjects you taught him in this month based on his class level</p>
              <div class="alert alert-success p-1">
                <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-1 font-italic">
                  <p class="sub-content">e.g Maths - 70%. English - 70%. Commerce - 40%. Accounts - 55% (please note very carefully that these scores here inform the client on where the child needs to focus and what kind of results the client should expect in their child's examination as you are scoring the child's knowledge of the subject based on his class not just what was taught</p>
                </blockquote>
              </div>
              <b-form-textarea rows="3" name="score" type="text" placeholder="Score your student's knowledge on the subjects you taught him" id="titleish" class="form-control" :class="{'is-invalid': errors.has('score')}" v-validate="'required'" v-model="score"></b-form-textarea><div class="invalid-feedback" v-show="errors.has('score')">{{ errors.first('score') }}</div>
            </div>

            <div class="form-group">
              <p class="title">My lesson experience was based on</p>
              <div class="col-12">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="homeworkSupport" id="defaultCheck1" v-model="methods" v-validate="'required'">
                  <label class="form-check-label" for="defaultCheck1">
                    Homework support
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="classRevision" id="defaultCheck1" v-model="methods" v-validate="'required'">
                  <label class="form-check-label" for="defaultCheck1">
                    Class Revision
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="myPlan" id="defaultCheck1" v-model="methods" v-validate="'required'">
                  <label class="form-check-label" for="defaultCheck1">
                    My lesson plan for the month
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="examPastQuestion" id="defaultCheck1" v-model="methods" v-validate="'required'">
                  <label class="form-check-label" for="defaultCheck1">
                    Exam past questions revision
                  </label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="other" id="defaultCheck1" v-model="methods" v-validate="'required'">
                  <label class="form-check-label" for="defaultCheck1">
                    Other
                  </label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <p class="title">What do you recommend can help improve the student's performance, also mention any other feedback you would like Prepclass to give to your client</p>
              <div class="alert alert-success p-1">
                <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-1 font-italic">
                  <p class="sub-content">(please note that this is the feedback to the client, what you answer here is what we will send to the client) Remember !! Tutors that provide clean and good feedback about tutoring sessions have a better chance of getting more learner requests from us.</p>
                </blockquote>
              </div>
              <b-form-textarea rows="3" name="recommendation" type="text" placeholder="What do you recommend can help improve the student's performance" id="titleish" class="form-control" :class="{'is-invalid': errors.has('recommendation')}" v-validate="'required|min:100'"  v-model="recommendation"></b-form-textarea><div class="invalid-feedback" v-show="errors.has('recommendation')">{{ errors.first('recommendation') }}</div>
            </div>

            <div class="form-group">
              <p class="title">Do you have any comment or concern you want Prepclass specifically to know</p>
              <div class="alert alert-success p-1">
                <blockquote style="background-color: rgba(255,255,255,0.5); margin: 0;" class="p-1 font-italic">
                  <p class="sub-content">This feedback goes to prepclass and is regularly read by the Manager of Prepclass NG limited. Remember !! Tutors that provide clean and good feedback about tutoring sessions have a better chance of getting more learner requests from us.</p>
                </blockquote>
              </div>
              <b-form-textarea rows="3" name="comments" type="text" placeholder="Do you have any comment or concern you want Prepclass specifically to know" id="titleish" class="form-control" :class="{'is-invalid': errors.has('comments')}" v-validate="'required'"  v-model="comments"></b-form-textarea><div class="invalid-feedback" v-show="errors.has('comments')">{{ errors.first('comments') }}</div>
            </div>

            <div class="form-group">
              <p class="title">How would you rate your overall satisfaction working with Prepclass</p>
              <div class="invalid-feedback" v-show="errors.has('prepclassRating')">{{ errors.first('prepclassRating') }}</div>
              <div class="col-12" style="margin-bottom: 10px">
                <div class="labels twopointone">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>10</span>
                </div>
                <div class="radios">
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="1"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="2"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="3"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="4"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="5"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="6"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="7"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="8"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="9"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" v-model="prepclassRating" name="prepclassRating" v-validate="'required'" value="10"></div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <p class="title">How would you rate your overall satisfaction working with your client</p>
                <div class="invalid-feedback" v-show="errors.has('clientRating')">{{ errors.first('clientRating') }}</div>
              <div class="col-12" style="margin-bottom: 10px">
                <div class="labels twopointone">
                  <span>1</span>
                  <span>2</span>
                  <span>3</span>
                  <span>4</span>
                  <span>5</span>
                  <span>6</span>
                  <span>7</span>
                  <span>8</span>
                  <span>9</span>
                  <span>10</span>
                </div>
                <div class="radios">
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="1"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="2"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="3"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="4"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="5"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="6"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="7"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="8"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="9"></div>
                  <div><input class="form-check-input" type="radio" id="exampleRadios1" name="clientRating" v-model="clientRating" v-validate="'required'" value="10"></div>
                </div>
              </div>
            </div>
          </div>

          <button v-if="modalIndex === 0" class="btn btn-success btn-lg submit-button" @click.prevent="incrementModalIndex">Next</button>
          <span v-else>
            <button class="btn btn-success btn-lg submit-button" @click.prevent="decrementModalIndex">Back</button>
            <button class="btn btn-success btn-lg submit-button" @click.prevent="submitClassDates" :disabled="saving">Submit <i class="fa fa-spin fa-circle-o-notch" v-show="submitting"></i></button>
          </span>
        </div>
      </b-modal>
      <!--// Submit classdates modal and form //-->
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';
import Editor from 'vue-ckeditor2';
import Datepicker from 'vuejs-datepicker';
import BrokenSpinner from '@/components/Preloaders/BrokenSpinner';

export default {
  name: 'tutor-classes',
  components: { Datepicker, BrokenSpinner, Editor },
  data() {
    return {
      to: null,
      from: null,
      query: '',
      summary: '',
      content: '',
      class_id: '',
      regarding: '',
      submitting: false,
      doneLoading: false,
      toolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
      ],
      selectedDates: [],
      disabledDates: [],
      dates: [],
      selectAttribute: {
        highlight: {
          backgroundColor: '#639440',
          borderRadius: '3px',
          width: '80%',
        },
      },
      modalIndex: 0,
      saving: false,
      active_class: '',
      API: `${BASE_API}/v1`,
      editorConfig: {
        toolbar: [
          { name: 'clipboard', items: ['Undo', 'Redo'] },
          { name: 'styles', items: ['Styles', 'Format'] },
          {
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Strike', '-', 'RemoveFormat'],
          },
          {
            name: 'paragraph',
            items: [
              'NumberedList',
              'BulletedList',
              '-',
              'Outdent',
              'Indent',
              '-',
              'Blockquote',
            ],
          },
          { name: 'tools', items: ['Maximize'] },
        ],
      },
      score: '',
      topics: '',
      methods: [],
      comments: '',
      progresss: '',
      clientRating: '',
      recommendation: '',
      prepclassRating: '',
    };
  },
  computed: {
    classes() {
      return this.$store.getters.session_classes;
    },
    filtered() {
      return this.classes.filter((c) => {
        // date filter
        const dt = moment(c.updated_at.date);
        // datefrom
        if (this.from !== null && !moment(dt).isAfter(moment(this.from))) {
          return false;
        }
        // dateto
        if (this.to !== null && !moment(dt).isBefore(moment(this.to))) {
          return false;
        }

        // filter for the search params
        return !(c.client && !c.client.name.toLowerCase().match(this.query.toLowerCase()));
      })
      .sort((a, b) => {
        if (! a.status) {
          return -1;
        }
        if (! b.status) {
          return -1;
        }
        return a.status.id - b.status.id;
      });
    },
    categories() {
      return this.$store.getters.ticket_categories;
    },
  },
  methods: {
    moments(val) {
      return moment(val).format('MMM D, YYYY');
    },
    async fetchDates() {
      try {
        const { data: { data: dates } } = await this.$http
          .get(`${this.API}/tutor/session-classes/${this.active_class}/dates`);
        this.dates = dates;
        this.filterDates(dates);
      } catch (e) {
        console.error(e);
      }
    },

    async fetchReport() {
      try {
        const { data: { data } } = await this.$http
          .get(`${this.API}/tutor/session-classes/${this.id}/report`);
        if (data.approved || data.declined) {
          return null;
        }
        this.score = data.score;
        this.topics = data.topics;
        this.methods = data.methods;
        this.comments = data.comments;
        this.progresss = data.progress;
        this.clientRating = data.clientRating;
        this.recommendation = data.recommendation;
        this.prepclassRating = data.prepclassRating;
        return true;
      } catch (e) {
        console.error(e);
      }
    },
    filterDates(dates) {
      this.selectedDates = dates.filter(d => !d.hasInvoice).map(d => new Date(d.date));
      this.disabledDates = dates.filter(d => d.hasInvoice).map(d => new Date(d.date));
    },
    showModal(classId) {
      this.class_id = classId;
      this.$refs.myModalRef.show();
    },
    showCalendar(classId) {
      this.active_class = classId;
      this.fetchDates();
      this.$refs.vcalendar.show();
    },
    hideModal() {
      this.resetModalForm();
      this.$refs.myModalRef.hide();
    },
    hideCalendar() {
      this.selectedDates = [];
      this.disabledDates = [];
      this.active_class = '';
      this.$refs.vcalendar.hide();
    },
    incrementModalIndex() {
      this.modalIndex = 1;
    },
    decrementModalIndex() {
      this.modalIndex = 0;
    },
    resetModalForm() {
      this.summary = '';
      this.content = '';
      this.class_id = '';
      this.regarding = '';
    },
    itemType(val) {
      switch (val && val.name) {
        case 'active':
          return 'success';
        case 'ended':
          return 'fail';
        default:
          return 'default';
      }
    },
    submit() {
      this.submitting = true;

      const data = {
        class_id: this.class_id,
        title: this.summary,
        category: this.regarding,
        description: this.content,
      };
      this.$store.dispatch('makeTicket', data)
        .then(() => {
          this.submitting = false;
          this.hideModal();
        })
        .catch(error => console.error(error));
    },
    saveDates() {
      return new Promise((resolve, reject) => {
        this.$http.post(`${this.API}/tutor/session-classes/${this.active_class}/dates`, {
          dates: this.selectedDates ? this.selectedDates.map(d => moment(d).format('YYYY-MM-DD')) : []
        })
          .then(({ data: { data } }) => {
            this.dates = data;
            this.filterDates(data);
            resolve(true);
          })
          .catch(err => reject(err));
      });
    },
    submitReport() {
      return new Promise((resolve, reject) => {
        const {
          score, topics, methods, comments, progresss,
          clientRating, recommendation, prepclassRating,
        } = this;
        this.$http.post(`${this.API}/tutor/session-classes/${this.active_class}/report`, {
          score,
          topics,
          methods: methods.join(),
          comments,
          clientRating,
          recommendation,
          prepclassRating,
          progress: progresss,
        })
          .then(({ data: { data } }) => {
            resolve(data);
          })
          .catch(err => reject(err));
      });
    },
    submitClassDates() {
      this.saving = true;
      this.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.saveDates()
              .then(() => {
                this.submitReport()
                  .then(() => {
                    this.saving = false;
                    swal(
                            "Success",
                            "Your class date report has been submitted successfully",
                            "success"
                    );
                    this.hideCalendar();
                    swal({
                      title: 'Congratulations!',
                      text: 'You have successfully submitted your class dates and reports 🎉. It would be reviewed and someone would get back to you shortly.',
                      icon: 'success',
                    });
                  })
                  .catch((err) => {
                    this.saving = false;
                    swal({
                      title: 'Oops!',
                      text: 'Something went wrong. Please contact support.',
                      icon: 'error',
                    });
                  });
              })
              .catch((err) => {
                this.saving = false;
                swal({
                  title: 'Oops!',
                  text: 'Something went wrong. Please contact support.',
                  icon: 'error',
                });
              });
          } else {
            this.saving = false;
            this.alertFormError();
          }
        });
    },    
    alertFormError() {
      swal(
        "Sorry",
        "There are some errors on the form. Please correct them and try again",
        "error"
      ).then(this.scrollToFirstError);
    },
  },
  mounted() {
    this.$store.dispatch('getClasses')
      .then(() => this.$store.dispatch('getCategories'))
      .then(() => this.doneLoading = true)
      .catch(error => swal('Something went wrong', error, 'error'));
  },
};
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }

  .btn.sb {
    float: right;
    margin-left: 20px;
    padding: 2px 15px;
    text-align: center;
    border-radius: 0px;
    font-size: 11px;
    vertical-align: middle;
    &:focus {
      outline: 0 !important;
      box-shadow: none !important;
      &:active {box-shadow: none !important;}
    }
  }
  .top {
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 25px 0;
  .tp {
    height: 64px;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
    width: 35%;
    .flt {
      font-size: 14px;
      font-weight: 600;
      color: rgba(77, 79, 92, 0.5);
      width: 30%;
      height: 100%;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      justify-content: center;
      align-items: center;
      border-right: 1px solid rgba(112, 112, 112, 0.3);
      svg {margin-right: 5px;}
    }
    .srch {
      width: 70%;
      height: 100%;
      padding: 15px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      input {
        font-size: 14px;
        width: 185px;
        height: 40px;
        box-shadow: 0 2px 2px 0 rgba(200, 200, 200, 0.14), 0 3px 1px -2px rgba(200, 200, 200, 0.12), 0 1px 5px 0 rgba(200, 200, 200, 0.2);
        border: 1px solid rgba(112, 112, 112, 0.02);
        padding: 15px;
        transition: all 0.29s ease;
        border-radius: 4px;
        &:focus {
          width: 215px;
          box-shadow: 0 8px 17px 2px rgba(200, 200, 200,0.14), 0 3px 14px 2px rgba(200, 200, 200,0.12), 0 5px 5px -3px rgba(200, 200, 200,0.2);
        }
      }
    }
    &:hover {.flt {color: #639440;}}
  }
  .input-daterange {
    width: 30%;
  }
  #exampleInputEmail3, #exampleInputEmail4 {
    width: 100%;
    height: 35px;
    line-height: 35px;
    border-radius: 18px;
    border: 1px solid rgba(112, 112, 112, 0.04);
    cursor: pointer;
    outline: none;
    font-size: 11px;
    box-shadow: 0 2px 2px 0 rgba(200, 200, 200, 0.14), 0 3px 1px -2px rgba(200, 200, 200, 0.12), 0 1px 5px 0 rgba(200, 200, 200, 0.2);
    text-align: center;
    transition: all .3s ease;
    &:active, &:hover { 
      box-shadow: 0 8px 17px 2px rgba(200, 200, 200,0.14), 0 3px 14px 2px rgba(200, 200, 200,0.12), 0 5px 5px -3px rgba(200, 200, 200,0.2);
    }
  }
  .vdp-datepicker__clear-button { position: absolute; top: 0; right: 0; }
}


  .hold {
    padding: 25px 0;
    height: 100%;
  }

  .container-material {
    display: block;
  }

  .aro {padding: 30px 0;}

  .ais {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }

  .card-ish {
    border: 1px solid rgba(224, 227, 218, .5);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.05);
    padding: 0;
    // margin: 0 23px;
    .top {
      padding: 15px 20px;
      position: relative;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      h5 {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #576271;
        font-size: 20px;
        justify-content: flex-start;
        font-weight: 500;
        svg {margin-right: 15px;}
      }
      button {
        height: 43px;
        width: 176px;
        border-radius: 4px;
        font-size: 14px;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);
      }
      .sasasa {
        position: absolute;
        height: 1px;
        width: calc(100% - 40px);
        box-shadow: 0 3px  6px rgba(0, 0, 0, 0.16);
        background-color: rgba(224, 227, 218, 1);
        bottom: 0;
      }
    }
    .body {
      position: relative;
      padding-bottom: 25px;
      .b {position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%);}
      .list {
        width: 90%;
        margin-top: 25px;
        margin-left: auto;
        margin-right: auto;
        .list--item {
          width: 100%;
          padding: 12px 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          color: #576271;
          border-bottom: 1px solid #E0E3DA;
          span {font-weight: 300; text-transform: capitalize;}
        }
      }
      .cdcol {
        height: 100%;
        padding: 30px;
        .title {
          font-weight: 600;
          color: #4D4F5C;
          font-size: 16px;
        }
        &:not(:last-child) {
          border-right: 1px solid #E0E3DA;
        }
        .items {
          ul {
            padding: 0;
            margin: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 15px;
            li {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              margin: 15px 0;
              text-transform: capitalize;
              svg { margin-right: 5px}
            }
          }
        }
      }
    }
    &.card-50 {
      width: 49%;
    }
    &.card-100 {
      width: 100%;
    }
    &.class-history, &.learner-detail {
      margin-right: 1%;
      .top {
        button {background-color: #109BF8; color: #ffffff;}
      }
    }
    &.ticket-history, &.client-detail {
      margin-left: 1%;
      .top {
        button {background-color: #F83B54; color: #ffffff;}
      }
    }
  }
  .table {
    margin-top: 20px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    thead {
      tr {
        td {
          border-top: none;
          color: #576271;
          text-transform: capitalize;
          font-size: 16px;
          font-weight: 300;
        }
      }
    }
    tbody {
      tr {
        &:hover {background-color: #fafafa;}
        td {
          color: #576271;
          text-transform: capitalize;
          font-size: 13px;
          padding: 20px 10px;
          border-top: 1px solid rgba(112, 112, 112, .12);
          a {
            color: #576271;
            text-transform: capitalize;
            font-size: 13px;
            &:hover {color: #639440; text-decoration: none;}
          }
          &.status {
            span {
              content: ' ';
              display: inline-block;
              margin-right: 5px;
              height: 10px;
              width: 10px;
              border-radius: 100%;
              background-color: #4D4F5C;
              &.active, &.open {background-color: #38ADB6;}
              &.ended {background-color: #F83B54;}
              &.paused {background-color: #FFBB03;}
            }
          }
        }
      }
    }
  }
  span.status {
    content: ' ';
    display: inline-block;
    margin-right: 5px;
    height: 10px;
    width: 10px;
    text-transform: capitalize;
    border-radius: 100%;
    background-color: #4D4F5C;
    &.active, &.open {background-color: #38ADB6;}
    &.ended {background-color: #F83B54;}
    &.paused {background-color: #FFBB03;}
  }
  @media only screen and (max-width: 600px) {
    .card-ish {
      &.card-50 {width: 100%; margin-bottom: 15px; margin-left: 0 !important; margin-right: 0 !important;}
    }
    .table {
      width: 100%;
      margin-left: 0;
      overflow-x: auto;
      thead {
        tr {
          td {font-size: 12px;}
        }
      }
      tbody {
        tr {
          td {
            font-size: 10px;
            a {font-size: 10px;}
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  .mkmodal {
    .modal-backdrop {
      opacity: 1;
      background-color: #E2E8ED;
      filter: blur(9px) brightness(50) opacity(50%);
    }
    .modal-content {
      border: none;
      box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.08);
      border-radius: 6px;
      .modal-header {
        justify-content: center;
        position: relative;
        border-bottom: none;
        .modal-title {
          text-align: center;
        }
        .close {
          float: right;
          right: 0;
          top: 0;
          margin: 0;
          position: absolute;
        }
      }
      .modal-body {
        width: 80%;
        margin-left: auto;
        margin-right: auto;
        .form-control {
          border-radius: 4px;
          border: 1px solid #E8E9EC;
          padding: 5px 15px;
          color: #4D4F5C;
          &::placeholder {color: #4D4F5C; opacity: 0.3;}
        }
        select.form-control {
          option {
            padding: 10px;
          }
        }
        .quillWrapper {
          .ql-toolbar.ql-snow {
            border: 1px solid #E8E9EC;
            border-top-right-radius: 4px;
            border-top-left-radius: 4px;
            text-align: left;
            padding: 4px 15px;
            .ql-formats {
              margin: 0;
            }
            .ql-picker-label {
              font-size: 13px;
            }
            button {
              svg {height: 16px; width: 16px}
            }
          }
          .ql-container.ql-snow {
            border: 1px solid #E8E9EC;
            border-bottom-left-radius: 4px;
            border-bottom-right-radius: 4px;
            border-top: none;
          }

        }
        .btn {
          width: 130px;
          height: 38px;
          line-height: 38px;
          padding: 0 10px;
          text-align: center;
          border-radius: 4px;
          font-size: 14px;
          vertical-align: middle;
          box-shadow: 0 2px 2px 0 rgba(40, 167, 69, 0.14), 0 3px 1px -2px rgba(40, 167, 69, 0.12), 0 1px 5px 0 rgba(40, 167, 69, 0.2);
          &:focus {
            outline: 0 !important;
            box-shadow: none !important;
            &:active {box-shadow: none !important;}
          }
        }
        .c-pane-container {
          width: 100%;
          margin-top: 0px;
          margin-bottom: 50px;
          border: none !important;
          background-color: #ffffff !important;

          .c-header {
            padding: 15px 10px;
            padding-bottom: 35px;
            .c-arrow-layout {
              padding: 10px;
              border: 1px solid #E8E9EC;
              box-shadow: 0 2px 3px rgba(0, 0, 0, 0.05);
              border-radius: 4px;
            }
            .c-title {
              font-size: 14px;
              color: #639440;
            }
          }
          .c-weekdays {
            .c-weekday {
              padding: 15px;
              font-size: 12px;
              font-weight: 600;
              background-color: rgba(221, 232, 213, 1);
            }
          }
          .c-week {
            .c-day-content {
              padding: 15px;
              font-size: 11px;
            }
          }
        }
      }
    }
  }
  .performance-report {
    .title {
      font-size: 1em;
      font-weight: 600;
      text-align: left;
      margin: 0;
    }
    .alert {
      margin-bottom: 8px;
    }
    .sub-content {
      text-align: left; font-size: .8em; margin-bottom: .5rem; font-style: italic;
    }
    .form-check {
      display: flex;
    }
    .labels {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-around;
      padding: 4px;
      &.twopointone {
        justify-content: space-around !important;
      }
      span {
        display: block;
        width: 15px;
      }
    }
    .radios {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-around;
      padding: 4px;
      div { height: 15px; width: 15px; }
      input { margin: 0; }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Pages/ClassSession/TutorClasses.vue